import Patrol from "../fragments/patrol";

export default `
query QueryPatrolStartTimesByServiceProvider($serviceProviderId: String!, $from: Float, $to: Float, $after: String) {
  queryPatrolsByServiceProviderIdStartTimeIndex(
    serviceProviderId: $serviceProviderId, 
    from: $from, 
    to: $to, 
    after: $after
  ) {
    nextToken
    items ${Patrol}
  }
}
`;
